import { CardTransactionType, PaymentDTO, Res } from 'core/api';

function isOldAdyenPayment(xml?: string): boolean {
	if (!xml)
		return true;
	return !xml.includes('<CardAlias>');
}

export function canRefundOriginalPayments(payments: PaymentDTO[], cardProcessorType: Nullable<CardTransactionType>, isCordovaDevice: boolean): { canRefund: boolean, reason: string } {

	if (payments.some(x => x.Amount < 0))
		return { canRefund: false, reason: Res.Msg.MSG_CANNOT_REFUND_ORIGINAL_PREPAYMENTS_PAYMENT() };

	// No puedo devolver los pagos si hay pagos con tarjeta y mi terminal no está configurado para ello
	if (cardProcessorType === null && payments.some(x => x.CardTransaction.TransactionId))
		return {
			canRefund: false,
			reason: Res.Msg.MSG_CANNOT_REFUND_ORIGINAL_CARD_PAYMENT_WHEN_CARD_PROCESSOR_IS_NOT_CONFIGURED(),
		};

	// No puedo devolver los pagos si son de ClearOne
	if (payments.some(x => x.CardTransaction.TransactionId && x.CardTransaction.TransactionType === CardTransactionType.ClearOne))
		return { canRefund: false, reason: Res.Msg.MSG_CANNOT_REFUND_ORIGINAL_CLEAR_ONE_CARD_PAYMENT() };

	// No puedo devolver los pagos si son de UnversalPay
	if (payments.some(x => x.CardTransaction.TransactionId && x.CardTransaction.TransactionType === CardTransactionType.UniversalPay))
		return { canRefund: false, reason: Res.Msg.MSG_CANNOT_REFUND_ORIGINAL_UNIVERSAL_PAY_PAYMENT() };

	if (payments.some(x => x.CardTransaction.TransactionId && x.CardTransaction.TransactionType === CardTransactionType.AdyenEcommerce))
		return { canRefund: false, reason: Res.Msg.MSG_CANNOT_REFUND_ORIGINAL_ADYEN_ECOMERCE_PAYMENT() };

	// No puedo devolver transacciones que no tengan CardAlias
	if (payments.some(x =>
		x.CardTransaction.TransactionId &&
		x.CardTransaction.TransactionType === CardTransactionType.Adyen &&
		isOldAdyenPayment(x.CardTransaction.XmlDetails)
	)) {
		return {
			canRefund: false,
			reason: Res.Msg.MSG_CANNOT_REFUND_ORIGINAL_OLD_ADYEN_CARD_PAYMENT(),
		};
	}

	if (payments.some(x => x.CardTransaction.TransactionId && x.CardTransaction.TransactionType === CardTransactionType.Redsys) && isCordovaDevice)
		return {
			canRefund: false,
			reason: Res.Msg.MSG_CANNOT_REFUND_ORIGINAL_REDSYS_CARD_PAYMENT_ON_PHONE_DEVICE(),
		};

	// No puedo devolver pagos que fueron realizados en otra pasarela
	const otherCardProcessorPayments = payments.filter(x => x.CardTransaction.TransactionId && x.CardTransaction.TransactionType !== cardProcessorType);
	if (cardProcessorType !== null && otherCardProcessorPayments.length > 0) {
		const otherProcessors = [...new Set(
			otherCardProcessorPayments.map(x =>
				CardTransactionType.toString(x.CardTransaction.TransactionType)
			)
		)].join(',');
		return {
			canRefund: false,
			reason: Res.Msg.MSG_CANNOT_REFUND_ORIGINAL_PAYMENT_FROM_OTHER_CARD_PROCESSORS(CardTransactionType.toString(cardProcessorType), otherProcessors),
		};
	}


	return { canRefund: true, reason: '' };
}